export default __webpack_public_path__ + "static/media/congratsKetoGoLarge.63798ed7.svg";